import React from 'react';
import Image from 'next/future/image';
import AuditFeaturesStyles from "./AuditFeaturesStyles";

const AuditFeaturesComponent = ({ title, subtitle, features, customClass = null }) => (

  < AuditFeaturesStyles className={customClass} >
    <section className="features-container container">
      <h2>{title}</h2>
      <div className="subtitle">{subtitle}</div>
      <div className="features-list">
        {features && features.map((feature, index) => (
          <div
            className="feature"
            key={index}
          >
            <div className="icon">
              <div className='icon-wrapper'>
                <Image src={feature.icon.url} width={1200}
                       height={600}
                       layout="raw" />
              </div>
            </div>
            <div className="bordered-container">
              <div className="content">
                <h3>{feature.title}</h3>
                <p>{feature.description}{feature.info && <span className="tooltip-inline">
                  <div className="tooltip-i"><img alt="Illustrative Image" width="50px" height="50px" src="/static/images/icons/extra-info-beige.svg" /></div>
                  <span
                    className="tooltip-text-inline"
                  >{feature.info}</span>
                </span>}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  </AuditFeaturesStyles >
);

export default AuditFeaturesComponent;
